const AboutUsSection = () => {
  return (
    <div
      className="section-full site-bg-white py-2 twm-abus-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        <div className="row twm-abus-section">

          {/* Left Section */}
          <div className="col-lg-7 col-md-12 d-none d-md-block">
            <div className="twm-abus-left">

              {/* Main Image */}
              <div className="twm-media d-none d-md-block">
                <img
                  src="/images/abus-pic.jpg"
                  alt="Garud Cab Service Pune"
                />

                {/* Video Button */}
                {/* <div className="twm-abus-video">
                  <a
                    href="#"
                    className="mfp-video"
                    aria-label="Garud Cab Service"
                  >
                    <i className="icon fa fa-play"></i>
                  </a>
                </div> */}

                {/* Year Section */}
                {/* <div className="twm-abus-year-section">
                  <div className="tem-abus-year-content">
                    <span>Since</span>
                    <h2 className="year-title">2016</h2>
                  </div>
                </div> */}
              </div>

              {/* Secondary Image */}
              <div className="twm-media2">
                <img
                  src="/images/car-pic1.png"
                  alt="Garud Cab Outstation Service"
                />
              </div>

            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-5 col-md-12">

            {/* Title */}
            <div className="section-head left aside-section">
              <div className="twm-sm-title left">
                About Garud Cab
              </div>

              <h2 className="twm-large-title site-text-dark">
                Your Trusted Cab Partner For Pune & Outstation Travel
              </h2>

              <div className="section-head-detail">
                Garud Cab Service provides reliable, comfortable and
                affordable cab services in Pune and across Maharashtra.
                Whether you need a local cab, Pune outstation taxi,
                airport transfer, Pune to Mumbai cab or a round-trip
                vehicle, we are here to make your journey safe and
                comfortable.
                <br />
                <br />
                With well-maintained vehicles and experienced drivers,
                Garud Cab Service is committed to providing a smooth,
                punctual and hassle-free travel experience for every
                customer.
              </div>
            </div>

            {/* Features List */}
            <div className="twm-inline-list2">
              <ul>
                <li>Wide Range Of Comfortable Vehicles</li>
                <li>Reliable Pune Outstation Cab Service</li>
                <li>24/7 Cab Booking & Customer Support</li>
              </ul>
            </div>

            {/* Read More Button */}
           
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;
